import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ObtenerDatosService } from 'src/app/servicios/datos/obtener-datos/obtener-datos.service';
import { GlobalesService } from 'src/app/servicios/globales.service'

@Component({
  selector: 'app-distribucion-votos',
  templateUrl: './distribucion-votos.component.html',
  styleUrls: ['./distribucion-votos.component.scss']
})
export class DistribucionVotosComponent implements OnInit {
  @Input() public contienda:string = '';
  objConfig: any = {};
  labels: any = {};
  addS = '';

  constructor(
    public _obtenerDatosService: ObtenerDatosService,
    public _globalService: GlobalesService,
    public activatedRoute: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.activatedRoute.data.subscribe(v => {
      console.log({v});
      this.labels.contienda = v.contienda || '[-]';
      this.labels.contienda_s = v.contienda_s || '[-]';
      this.labels.candidatura = v.candidatura || false;

      console.log(v.candidatura);
      console.log(true);

      let selectedContienda = this._globalService.getContienda();
      this.addS = ((selectedContienda == 'diputaciones') && `${v.contienda}` == 'Distritos' ) ? '' : 's'
      //console.log('CONTIENDA: ',v.contienda, '  , ', v.contienda_s, '   , ',selectedContienda)
    });

    this._obtenerDatosService.configSubject.subscribe(data =>{
			if (data != null) this.objConfig = data;
		});
  }



}
